tariffsBuy = {
	init: function() {
		// Создаём глобальную очередь сразу при инициализации
		this.setupPayLateQueue();
		this.bindEvents();
		
		if ($('[data-paylate-config]').length)
			this.initPayLate();
	},
 
	setupPayLateQueue: function() {
		if (typeof window.__pl_queue === 'undefined') {
			window.__pl_queue = [];
		}
		
		window.__pl_enqueue = function(config) {
			window.__pl_queue.push(config);
		};
	},
	
	bindEvents: function() {
		var self = this;
 
		// Обработка платёжной формы (шаги)
		$(document).on('submit', '.tariffs-buy form', function(e) {
			var $form = $(this);
			
			// Проверяем наличие data-step
			if (!$form.attr('data-step')) return;
 
			var step = $form.data('step');
			
			// Обрабатываем только первый шаг
			if (step != '1') return;
 
			e.preventDefault();
 
			var
				orderId = $form.find('input[name="order"]').val(),
				productId = new URLSearchParams(window.location.search).get('product') || '',
				selectedPaySystem = $form.find('input[name="paySystem"]:checked').val();
 
			// Проверяем, что выбрана платёжная система
			if (!selectedPaySystem) {
				alert('Выберите способ оплаты');
				
				return;
			}
			
			// Загружаем второй шаг
			$.ajax({
				url: '/local/templates/planb/components/planb/tariffs/.default/ajax.php',
				type: 'GET',
				data: {
					product: productId,
					step: '2',
					order: orderId,
					paySystem: selectedPaySystem,
					bonusAmount: $form.find('.js-buy-partial input').val() || '',
				},
 
				success: function(response) {
					var $newContent = $(response).find('#tariffs_buy_body');
					
					if ($newContent.length) {
						$('#tariffs_buy_body').html($newContent.html());
						self.initPayLate();

						// Автоматическая отправка формы оплаты
						var
							$buyNote = $('#tariffs_buy_body .buy__note');
						
						if ($buyNote.length) {
							var
								$form = $buyNote.find('form'),
								$button = $buyNote.find('input[type="submit"], button[type="submit"], button');

							if ($form.length) $form.submit();
							else if ($button.length) $button.click();
						}
					}
				},
 
				error: function() {
					alert('Произошла ошибка при загрузке формы оплаты.');
				}
			});
		});

		// Частичная оплата бонусами
		$(document).on('change', '.js-tariffs-buy input[name="paySystem"]', function() {
			var
				$partial = $('.js-buy-partial'),
				isInner = $(this).attr('data-inner') == 1;
			
			if (isInner) $partial.hide();
			else $partial.show();
		});
		
		// Валидация поля частичной оплаты
		$(document).on('input', '.js-buy-partial-input', function() {
			var
				$input = $(this),
				value = parseFloat($input.val()) || 0,
				max = parseFloat($input.attr('max')) || 0;
			
			if (value > max) $input.val(max);
			if (value < 0) $input.val(0);
		});

		// Оплата бонусами
		$(document).on('click', '.js-pay-bonus', function(e) {
			e.preventDefault();
			
			var
				$button = $(this),
				$success = $('.js-paybonus-success'),
				$error = $('.js-paybonus-error'),
				orderId = $button.data('order'),
				paymentId = $button.data('payment');
				
			if ($button.hasClass('loading')) return;
			
			$button.addClass('loading').prop('disabled', true);
			$success.hide();
			$error.hide();
			
			$.ajax({
				url: '/local/templates/planb/components/planb/tariffs.buy/.default/ajax/paybonus.php',
				method: 'POST',
				data: {
					order: orderId,
					payment: paymentId,
					sessid: BX.bitrix_sessid()
				},
				dataType: 'json',
				
				success: function(response) {
					if (response.result) {
						$button.hide();
						$('.js-paybonus-amount').text(response.data.amount);
						$('.js-paybonus-balance').text(response.data.balance);
						$success.show();
						
						// Перенаправляем на страницу успешной оплаты
						setTimeout(function() {
							window.location.href = '/personal/order/success.php?ORDER_ID=' + response.data.orderId;
						}, 2000);
					}
					
					else {
						$('.js-paybonus-error-text').text(response.error);

						$error.show();
						$button.removeClass('loading').prop('disabled', false);
					}
				},
				
				error: function() {
					$('.js-paybonus-error-text').text('Произошла ошибка при оплате.');

					$error.show();
					$button.removeClass('loading').prop('disabled', false);
				}
			});
		});
	},
	
	initPayLate: function() {
		var self = this;
		
		function processQueue() {
			if (typeof window.PayLateButton !== 'function') return false;
			
			var queue = window.__pl_queue.slice();
			window.__pl_queue.length = 0;
			
			queue.forEach(function(config) {
				try {
					window.PayLateButton(config);
				} catch(error) {
					console.error('PayLate error:', error);
				}
			});
			
			return true;
		}
		
		// Получаем конфиг из data-атрибута
		var $configElement = $('[data-paylate-config]');
		if ($configElement.length) {
			var configLiteral = $configElement.data('paylate-config');
			
			if (configLiteral) {
				try {
					var config = (new Function('return (' + configLiteral + ');'))();
					if (config) window.__pl_enqueue(config);
				} catch (error) {
					console.error('PayLate config parse error:', error);
				}
			}
		}
		
		if (typeof window.PayLateButton !== 'function' && 
			!document.querySelector('script[src*="lk.paylate.ru/js/partner_im.js"]')) {
			var script = document.createElement('script');
			script.src = 'https://lk.paylate.ru/js/partner_im.js';
			script.onload = processQueue;
			document.head.appendChild(script);
		}
		
		processQueue();
	}
 };

 
 
 $(document).ready(function() {
	tariffsBuy.init();
 });